import {Component, OnInit} from '@angular/core';
import {DataStorageService} from '../../../../data-storage.service';
import {ApiService} from '../../../../api.service';
import {PricingService} from '../../../../pricing.service';
import {NumbersPricingModel} from '../../../../../models/numbersPricing.model';
import {PhoneNumbersToBePortedRange} from '../../../../../models/phoneNumbersToBePortedRange';

@Component({
  selector: 'app-range-ported',
  templateUrl: './range.component.html',
  styleUrls: ['./range.component.scss']
})
export class RangePortedComponent implements OnInit {

  connections: string[];
  counts: number[];
  pricingList: NumbersPricingModel[];

  constructor(
    public dataStorageService: DataStorageService,
    private api: ApiService,
    private pricing: PricingService) {
    this.connections = [];
    this.counts = [];
    this.pricingList = [];

    const connectionType = new Set();
    const totalCount = new Set();
    const costMonthly = new Set();
    const costUnique = new Set();
    pricing.getPortedNumbersPricelist().then(data => {
      this.pricingList = data;
      data.map(e => {
        connectionType.add(e.connectionType);
        totalCount.add(e.totalCount);
        costMonthly.add(e.costMonthly);
        costUnique.add(e.costUnique);
      });
      this.connections = Array.from(connectionType);
      console.log(this.connections );
      this.counts = Array.from(totalCount);
    });

  }

  filterTotalCount(conn: string) {
    const filtered = this.pricingList.filter(e => {
      return e.connectionType === conn || conn === "Economy Line";
    });
    const toReturn = new Set();
    filtered.map(e => {
      toReturn.add(e.totalCount);
    });
    return Array.from(toReturn);
  }

  ngOnInit() {
  }

  addRangeClick() {
    this.api.postPortedNumbers(this.dataStorageService.currentState.offerID)
      .then((range) => {
        this.dataStorageService.currentState.phoneNumbersToBePorted.range.push(range);
      });
  }

  toTranslate(tech: string): string {
    return tech.split(' ')[0];
  }
  setValue(i: number, event: any, field: string) {
    const range = this.dataStorageService.currentState.phoneNumbersToBePorted.range[i];

    range[field] = event.target.value;

    if (field === 'connectionType') {
      const tc = this.filterTotalCount(event.target.value);
      range['totalCount'] = tc[0];
    }
    range.costMonthly = this.calculateMonthly(range);
    range.costUnique = this.calculateUnique(range);
    this.api.putPortedNumbers(this.dataStorageService.currentState.offerID);
  }

  async update() {
    await this.api.putPortedNumbers(this.dataStorageService.currentState.offerID);
  }

  removeRangeClick(i: number) {
    this.api.deletePortedNumbers(
      this.dataStorageService.currentState.offerID,
      this.dataStorageService.currentState.phoneNumbersToBePorted.range[i].id)
      .then(() => {
        this.dataStorageService.currentState.phoneNumbersToBePorted.range.splice(i, 1);
      });
  }

  calculateMonthly(range: PhoneNumbersToBePortedRange) {
    const filtered = this.pricingList.filter(e => e.connectionType === range.connectionType);
    range.totalCount = parseInt(range.totalCount.toString(), 10);
    const count = filtered.filter(e => e.totalCount === range.totalCount);
    range.costMonthlyEdit = count.length === 1 ? count[0].costMonthlyEdit : false;
    return count.length === 1 ? 0 + (count[0].costMonthly) : 0;
  }

  calculateUnique(range: PhoneNumbersToBePortedRange) {
    range.totalCount = parseInt(range.totalCount.toString(), 10);
    const filtered = this.pricingList.filter(e => e.connectionType === range.connectionType);
    const count = filtered.filter(e => e.totalCount === range.totalCount);
    range.costUniqueEdit = count.length === 1 ? count[0].costUniqueEdit : false;
    return count.length === 1 ? 0 + (count[0].costUnique) : 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/content/new-offer/phone-numbers-to-be-ported/range/range.component.ts